import React from "react";
import "./Dropdown.css";

const Dropdown = ({ label, value, options, onChange }) => {
  return (
    <div className="dropdown-label">
      <div>
        <label className="label-wrapper">{label}</label>
      </div>
      <select value={value} onChange={onChange}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
